// @ts-nocheck
import React from 'react';
import FAQ from 'react-faq-component';
import { JsonLd, toPlainText } from '../jsonLd/jsonLd.comp';
import { Section } from '../section/section.comp';
import { StyledDiv } from './faq.styles';


interface IFaqProps {
    faqs: { q: string, a: string; }[];
    mode?: 'light' | 'dark';
}

export const Faq = ({ faqs = [], mode = 'light' }: IFaqProps) => {
    if (!faqs.length) return <></>;
    const data = {
        rows: faqs.map((faq) => ({ title: faq.q.replace(/<[^>]*>/g, ''), content: faq.a }))
    };

    const styles = {
        rowTitleColor: mode === 'light' ? "#292929" : '#fff',
        rowTitleTextSize: "18px",
        rowContentTextSize: "16px",
        rowContentColor: mode === 'light' ? "#292929" : '#fff',
        rowContentPaddingBottom: '20px',
        rowContentPaddingTop: '0px',
        arrowColor: "#6881E9",
        bgColor: mode === 'light' ? "#fff" : '#171B2C',
    };

    const config = {
        animate: true,
        tabFocus: true,
    };

    return (
        <>
            <FaqScripts faqs={faqs} />
            <Section mode={mode} className="faq-section">
                <StyledDiv className={`faq-section-content ${mode}`}>
                    <h3>FAQ</h3>
                    <FAQ config={config} styles={styles} data={data} />
                </StyledDiv>
            </Section>
        </>
    );
};


const FaqScripts = ({ faqs }: { faqs: { q: string, a: string; }[]; }) => {
    const rows = (faqs || [])
        .map((item) => ({ q: toPlainText(item?.q), a: toPlainText(item?.a) }))
        .filter((item) => item.q && item.a);

    if (!rows.length) return <></>;

    return (
        <JsonLd
            data={{
                '@context': 'https://schema.org',
                '@type': 'FAQPage',
                mainEntity: rows.map((item) => ({
                    '@type': 'Question',
                    name: item.q,
                    acceptedAnswer: { '@type': 'Answer', text: item.a },
                })),
            }}
        />
    );
};
